import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col span-6" }
const _hoisted_3 = { class: "col span-6" }

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { LabeledInput } from '@components/Form/LabeledInput';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import { _EDIT } from '@shell/config/query-params';
import { DURATION_UNITS, DurationUnit, durationToParts, partsToDuration } from '../utils/duration';

/**
 * Value/unit pair bound to a single Go duration string. Emits `undefined` when cleared so the
 * caller can drop the field from the spec rather than persisting an empty string.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DurationInput',
  props: {
    value: { default: undefined },
    label: { default: '' },
    mode: { default: _EDIT },
    tooltip: { default: undefined }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n(useStore());

const initialParts = durationToParts(props.value);
const amount = ref(initialParts ? String(initialParts.value) : '');
const unit = ref<DurationUnit>(initialParts?.unit || 'd');

const unitOptions = computed(() => DURATION_UNITS.map((u) => ({ label: t(`certManager.duration.unit.${ u }`), value: u })));

// Keep in step when the parent replaces the resource, e.g. after a save or a form reset.
watch(() => props.value, (neu) => {
  if (neu === partsToDuration(amount.value, unit.value)) {
    return;
  }

  const parts = durationToParts(neu);

  amount.value = parts ? String(parts.value) : '';
  unit.value = parts?.unit || 'd';
});

function update() {
  emit('update:value', partsToDuration(amount.value, unit.value));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(LabeledInput), {
        value: amount.value,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
          update
        ],
        type: "number",
        min: "0",
        label: __props.label,
        mode: __props.mode,
        tooltip: __props.tooltip
      }, null, 8, ["value", "label", "mode", "tooltip"])
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(LabeledSelect, {
        value: unit.value,
        "onUpdate:value": [
          _cache[1] || (_cache[1] = ($event: any) => ((unit).value = $event)),
          update
        ],
        label: _unref(t)('certManager.duration.unitLabel'),
        options: unitOptions.value,
        mode: __props.mode
      }, null, 8, ["value", "label", "options", "mode"])
    ])
  ]))
}
}

})